var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vendor"}},[_c('div',{staticClass:"vendor-page-bg"},[_c('vendor-search',{attrs:{"vendor":_vm.vendorName},on:{"searchClicked":_vm.searchForProduct}})],1),_c('div',{attrs:{"id":"searchResult"}},[(_vm.searchResult.length > 0)?_c('search-result-view',{attrs:{"data":_vm.searchResult}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }